/**
 * shared/firebase.js
 * Firebase initialisation shared by all frontend apps.
 * Both apps read from the same REACT_APP_FIREBASE_* env vars
 * (each app has its own .env file with the same values).
 */
import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  experimentalAutoDetectLongPolling: false,
  useFetchStreams: false,
});
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const messaging = typeof window !== "undefined" && "serviceWorker" in navigator ? getMessaging(app) : null;
